namespace pixi_ui.component {
    import Graphics = PIXI.Graphics;

    interface IMaskOffset {
        top: number;
        right: number;
        bottom: number;
        left: number;
    }

    export class Mask implements IComponent {
        public graphics: Graphics;
        public offset: IMaskOffset;

        constructor(offset: IMaskOffset) {
            this.graphics = new Graphics();
            this.offset = offset;
        }

        public attach(element: Element): void {
            this.graphics.beginFill(0, 1);
            this.graphics.drawRect(
                0,
                0,
                Math.abs(
                    element.elementWidth - this.offset.right - this.offset.left
                ),
                Math.abs(
                    element.elementHeight - this.offset.bottom - this.offset.top
                )
            );
            this.graphics.endFill();
            this.graphics.x = this.offset.left;
            this.graphics.y = this.offset.top;

            element.addChild(this.graphics);
            element.mask = this.graphics;
        }

        public detach(element: Element): void {
            element.mask = null;
            element.removeChild(this.graphics);
        }

        public resize(element: Element): void {
            this.graphics.clear();
            this.graphics.beginFill(0, 1);
            this.graphics.drawRect(
                0,
                0,
                Math.abs(element.elementWidth - this.offset.right),
                Math.abs(element.elementHeight - this.offset.bottom)
            );
            this.graphics.endFill();
        }
    }
}
